import { createContext, useCallback, useContext, useEffect, useState } from "react";
import { api } from "@/lib/api";
import { PRODUCTS } from "@/data/products";

const ProductsContext = createContext({ products: PRODUCTS, loaded: false, refresh: () => {} });

export const ProductsProvider = ({ children }) => {
  const [products, setProducts] = useState(PRODUCTS);
  const [loaded, setLoaded] = useState(false);

  const refresh = useCallback(async () => {
    try {
      const res = await api.get("/products");
      if (Array.isArray(res.data) && res.data.length) setProducts(res.data);
    } catch (e) {
      // keep the built-in catalogue when the API is unreachable
    } finally {
      setLoaded(true);
    }
  }, []);

  useEffect(() => { refresh(); }, [refresh]);

  return <ProductsContext.Provider value={{ products, loaded, refresh }}>{children}</ProductsContext.Provider>;
};

export const useProducts = () => useContext(ProductsContext);
